/**
 * Returns true if object is null or length is 0
 * @param {AnyObject} object - either null or any object
 */
const isObjectEmpty = (object) => {
    return object ? Object.keys(object).length === 0 : true;
};
export default isObjectEmpty;
